import { LogEntryItemCombinedProps } from './types';

const usePresenter = (props: LogEntryItemCombinedProps): LogEntryItemCombinedProps => {
  return props;
};

export default usePresenter;
